 
import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";  
import useMaxCopayScheduleSteps from "./hooks/useMaxCopayScheduleSteps";  
  
const MaxCopayScheduleSteps = () => {  
  const maxCopayScheduleStepsData = useMaxCopayScheduleSteps();  
  
  return (  
    <div class="container container-fluid">
      <ButtonsSection ctaButtons={maxCopayScheduleStepsData.leftButtons} align="left" />   
      <div className="header-section">  
        <h1>  
          {maxCopayScheduleStepsData.screen_title} -{" "}  
          <span className="heading-cod">  
            {maxCopayScheduleStepsData.screenNumber}  
          </span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={maxCopayScheduleStepsData.formFields}  
        dropdownValues={maxCopayScheduleStepsData.dropdownValues}  
        paramsData={maxCopayScheduleStepsData.paramsData}  
        updataParamData={maxCopayScheduleStepsData.updateParamData}  
      />  
      <ButtonsSection ctaButtons={maxCopayScheduleStepsData.ctaButtons} />  
      <DisplayTable  
        data={maxCopayScheduleStepsData.data}  
        parmKey={maxCopayScheduleStepsData.parmKey}  
        menuOptions={maxCopayScheduleStepsData.menuOptions}  
        tableHeaders={maxCopayScheduleStepsData.columnDef}  
        setRowData={maxCopayScheduleStepsData.setRowData}  
        selectedPriceSchedules={maxCopayScheduleStepsData.selectedRows}  
        setSelectedPriceSchedules={maxCopayScheduleStepsData.setSelectedRows}  
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={maxCopayScheduleStepsData.first}  
          rows={maxCopayScheduleStepsData.rows}  
          totalRecords={maxCopayScheduleStepsData.totalRecords}  
          currentPage={maxCopayScheduleStepsData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={maxCopayScheduleStepsData.onPageChange}  
        />  
      </div>  
      {maxCopayScheduleStepsData.isConfirmationModalOpen && (  
        <ConfirmationModal  
          isOpen={maxCopayScheduleStepsData.isConfirmationModalOpen}  
          onRequestClose={maxCopayScheduleStepsData.closeConfirmationModal}  
          onBack={maxCopayScheduleStepsData.closeConfirmationModal}  
          onSave={maxCopayScheduleStepsData.deletePriceSchedule}  
          confirmLabel="Confirm(Y/N)"  
          options={[  
            { label: "N-No", value: "no" },  
            { label: "Y-Yes", value: "yes" },  
          ]}  
          setSelectedOption={maxCopayScheduleStepsData.setSelectedOption}  
        />  
      )}  
    </div>  
  );  
};  
  
export default MaxCopayScheduleSteps;  
 
